import React from "react";

export default function InputBase(props) {
  return <input {...props} ref={props?.inputRef} />;
}
